module.exports = __webpack_public_path__ + "16865f19.svg";